// extracted by mini-css-extract-plugin
export var container = "Note-module--container--TkVp0";
export var textarea = "Note-module--textarea--R68Ih";